import { memo } from 'react';
import { IconProps } from './iconType';

export const PeopleIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
      <path
        d="M19 22H3V20C3 18.6739 3.52678 17.4021 4.46447 16.4645C5.40215 15.5268 6.67392 15 8 15H14C15.3261 15 16.5979 15.5268 17.5355 16.4645C18.4732 17.4021 19 18.6739 19 20V22ZM11 13C10.2121 13 9.43185 12.8448 8.7039 12.5433C7.97595 12.2417 7.31451 11.7998 6.75736 11.2426C6.20021 10.6855 5.75825 10.0241 5.45672 9.2961C5.15519 8.56815 5 7.78793 5 7C5 6.21207 5.15519 5.43185 5.45672 4.7039C5.75825 3.97595 6.20021 3.31451 6.75736 2.75736C7.31451 2.20021 7.97595 1.75825 8.7039 1.45672C9.43185 1.15519 10.2121 1 11 1C12.5913 1 14.1174 1.63214 15.2426 2.75736C16.3679 3.88258 17 5.4087 17 7C17 8.5913 16.3679 10.1174 15.2426 11.2426C14.1174 12.3679 12.5913 13 11 13Z"
        fill={color}
      />
    </svg>
  );
});

PeopleIcon.displayName = 'PeopleIcon';
